class BlogArticlesSearch extends HTMLElement {
  constructor() {
    super();    

    this.type = this.getAttribute('data-type');
    
    this.searchClient = algoliaShopify.externals.algoliasearch(algoliaShopify.config.app_id, algoliaShopify.config.search_api_key);

    this.articlesIndex = this.searchClient.initIndex(
      `${algoliaShopify.config.index_prefix}articles`
    );

    this.lastQuery = false;
    this.query = '';

    this.container = this;
    this.input = this.querySelector('#blog-articles-search')
    this.articlesContainer = this.querySelector('#AlgoliaSearchResultsArticles');

    this.debouncedInput = debounce((event) => {
      this.onSearchInput(event);
    }, 300);

    this.input.addEventListener('focus', this.onSearchFocus.bind(this));
    this.input.addEventListener('input', this.debouncedInput.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onSearchFocus(event) {
    if (this.lastQuery !== this.query) {
      this.lastQuery = this.query;
      this.search();
    }
  }

  onSearchInput(event) {
    this.query = event.target.value;
    this.search();
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
        this.lastQuery = false;
      }
    });
  }

  search() {
    this.articlesIndex
      .search(this.query, {
        hitsPerPage: 10,
        attributesToRetrieve: ['*'],
        clickAnalytics: true,
        facetFilters: [this.type == 'articles' ? 'blog.title:-Support Articles' : ['blog.title:Support Articles', 'blog.title:Customer Service']],
      })
      .then(({ hits }) => {
        const container = document.createElement('div');
        container.classList.add('articles-search-results');

        const header = document.createElement('div');
        header.classList.add('articles-search-results__header');
        header.innerHTML = `
          <h2 class='articles-search-results__header-title'>${this.type == 'articles' ? 'Blog Posts' : 'Support'}</h2>
        `;
        container.appendChild(header);

        const list = document.createElement('ul');
        list.classList.add('articles-search-results__list');
        container.appendChild(list);

        hits.forEach((hit) => {
          const li = document.createElement('li');
          li.classList.add('articles-search-results__item');
          list.appendChild(li);

          const a = document.createElement('a');
          a.classList.add('articles-search-results__item-link', 'link', 'full-unstyled-link');
          a.href = `/blogs/${hit.blog.handle}/${hit.handle}`;
          a.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
              <path d="M0.531479 9.41435C0.208032 9.67311 0.155591 10.1451 0.414348 10.4685C0.673106 10.792 1.14507 10.8444 1.46852 10.5857L1 10L0.531479 9.41435ZM11.7454 2.08282C11.7912 1.67114 11.4945 1.30033 11.0828 1.25459L4.37411 0.509174C3.96243 0.463432 3.59161 0.760084 3.54587 1.17176C3.50013 1.58344 3.79678 1.95426 4.20846 2L10.1718 2.66259L9.50917 8.62589C9.46343 9.03757 9.76008 9.40839 10.1718 9.45413C10.5834 9.49987 10.9543 9.20322 11 8.79154L11.7454 2.08282ZM1 10L1.46852 10.5857L11.4685 2.58565L11 2L10.5315 1.41435L0.531479 9.41435L1 10Z" fill="#aa5707"></path>
            </svg>
            <span>${hit.title}</span>
          `;
          li.appendChild(a);
        });

        this.articlesContainer.innerHTML = '';
        this.articlesContainer.appendChild(container);
      });
  }

  close() {
    this.articlesContainer.innerHTML = '';
  }
}

customElements.define('blog-articles-search', BlogArticlesSearch);
